import React, {useState, useRef, useEffect} from "react";
import { Link, useLocation } from 'react-router-dom';
import cx from 'classnames';
import Sugar from "sugar";

import { isSameScorecard, splitSchoolName } from "../Helpers"

import SearchSort from "../search/SearchSort"

import Deploy from "../Deploy";

import { TrackingLink } from "../modules/TrackingLink";

Sugar.extend();

const getPercent = ( amount, min, max ) =>
{
  return (amount - min) / (max - min) * 100;
}

function ScorecardDetailSparkChartBar({ scorecard, min, max }) {

  const debtPercent = getPercent( scorecard.debt, min, max );
  const incomePercent = getPercent( scorecard.income, min, max );

  return (
    <div className={ cx( 'spark-chart-container-bar' )}>

      <div className="offset">
      <div
        className={ cx( 'graphic bar', {income: scorecard.debt <= scorecard.income, debt: scorecard.debt > scorecard.income} )}
        style={{ left: Math.min( debtPercent, incomePercent ) + '%' , width: Math.max( debtPercent, incomePercent ) -  Math.min( debtPercent, incomePercent ) + '%' }}
      >
      </div>

      <div
        className="text debt"
        style={{ right: (100 - debtPercent )+"%" }}
      >
        ${ Math.round(scorecard.debt/1000) }k
      </div>

      <div
        className="graphic handle debt"
        style={{ left: debtPercent +"%" }}
      >
      </div>

      <div
        className="graphic handle income"
        style={{ left: incomePercent +"%" }}
      >
      </div>

      <div
        className="text income"
        style={{ left: incomePercent +"%" }}
      >
      ${ Math.round(scorecard.income/1000) }k/yr
      </div>

</div>
    </div>
  );
}

function LinkRow({ major, search, children })
{
  return (<TrackingLink to={{
      pathname: `/scorecard/${ major.unitid }/${ major.cipCode}/${ major.degreeLevel }`,
      search: search
    }} className="spark-chart-row" event="jump_from_compare">
    { children }
  </TrackingLink>
)
}

function PlainRow({ children })
{
  return (<>
    { children }
  </>)
}

function ScorecardDetailSparkChart({ majors, scorecard }) {
  const min = 0;//Math.max( Math.min( majors.min( 'debt' ).debt, majors.min('income').income ) - 20000, 0 );
  const max = majors.length
    ? Math.max( majors.max( 'debt' ).debt, majors.max('income').income ) + 20000
    : 20000;

  const [sortBy, setSortBy] = useState({
    field: 'income',
    desc: true,
    title: "Income, Highest To Lowest"
  });

  const location = useLocation();
  const index = majors.findIndex( isSameScorecard.partial(scorecard) );
  const start = Math.max( index - 1, 0 );

  // const window = majors.sortBy('income', true).from(index).to(3);

  const ticks = (0).upto(max, 20000).map( i => <div key={i} className="tick" style={{ left: getPercent(i, min, max) + "%"}}><span className="value">${ Math.round(i/1000) }k</span></div> )
// { major.unitid }, { major.opeid }, { major.opeid6 }



  return (
    <>
    <div className="spark-chart-container">

      {
        majors.sortBy(sortBy.field, sortBy.desc ).map( major => {
          const { school, campus } = splitSchoolName( major.school );
          const row = <>
            <div className="spark-chart-container-school">
              { school }<br/>
            <small>{ campus }</small>
            </div>

            <div style={{ display: 'flex', width: '70%' }}>
              <ScorecardDetailSparkChartBar scorecard={major} min={ min } max={ max } />
            </div>
          </>

          return (
          <div key={ major.unitid } className={ cx( 'spark-chart-container-entry', {current: isSameScorecard( major, scorecard ), reverse: major.debt > major.income } ) }>
            <Deploy.Widget>
              <PlainRow>
                { row }
              </PlainRow>
            </Deploy.Widget>

            <Deploy.Tool>
              <LinkRow major={ major } search={ location.search }>
                { row }
              </LinkRow>
            </Deploy.Tool>

          </div>
        )} )
      }

      <div className="ticks">
        { ticks }
      </div>
    </div>

    </>
  );
}



export default ScorecardDetailSparkChart;
